import * as React from "react";
import { forwardRef } from "react";
const SvgStop = (props, ref) => /* @__PURE__ */ React.createElement("svg", { viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", ref, ...props }, /* @__PURE__ */ React.createElement("rect", { x: 7, y: 7, width: 10, height: 10, fill: "currentcolor" }));
const ForwardRef = forwardRef(SvgStop);
export default ForwardRef;
